import { PropsWithChildren } from 'react';

import InfoIcon from '@mui/icons-material/Info';
import Avatar from '@mui/material/Avatar';
import IconButton from '@mui/material/IconButton';
import ListItem from '@mui/material/ListItem';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import ListItemText from '@mui/material/ListItemText';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import Tooltip from '~/components/CommonTooltip';

export type InfoListItemPropOptions = {
  title: string;
  avatarIcon?: (props: any) => JSX.Element;
  avatarIconColor?: string;
  textColor?: string;
  tooltipText?: string;
  inlineCTA?: JSX.Element | null;
};

const InfoListItem = ({
  title,
  avatarIcon: AvatarIcon = undefined,
  avatarIconColor = undefined,
  textColor = undefined,
  tooltipText = undefined,
  inlineCTA = null,
  children = null,
}: PropsWithChildren<InfoListItemPropOptions>) => {
  return (
    <ListItem
      disableGutters
      dense
      alignItems={'center'}
      data-testid="info-list-item"
    >
      {!!AvatarIcon && (
        <ListItemAvatar>
          <Avatar>
            <AvatarIcon {...(avatarIconColor && { color: avatarIconColor })} />
          </Avatar>
        </ListItemAvatar>
      )}
      <ListItemText
        primary={
          <Stack direction="row" alignItems="center">
            <Typography
              variant="body2"
              {...(textColor && { color: textColor })}
            >
              {title}
            </Typography>
            {tooltipText && (
              <Tooltip
                title={tooltipText}
                arrow
                placement="top-start"
                data-testid="info-list-item-tooltip"
              >
                <IconButton>
                  <InfoIcon />
                </IconButton>
              </Tooltip>
            )}
            {inlineCTA}
          </Stack>
        }
        {...(children && {
          secondary: (
            <Typography variant="body1" component="span">
              {children}
            </Typography>
          ),
        })}
      />
    </ListItem>
  );
};

export default InfoListItem;
